import Collapse from "antd/lib/collapse"
import React from "react"
import styled from "styled-components"
import {Card} from "../../../components/Card"

const ReportCard = (props) => {
  if (!props.collapsible) {
    return <CardStyled padded={props.padded}>{props.children}</CardStyled>
  }

  return (
    <CardStyled padded={props.padded}>
      <Collapse
        bordered={props.bordered}
        defaultActiveKey={["1"]}
        expandIconPosition="right"
      >
        <Collapse.Panel header={props.header} key="1">
          {props.children}
        </Collapse.Panel>
      </Collapse>
    </CardStyled>
  )
}

const CardStyled = styled(Card)`
  margin-bottom: ${(props) => props.theme.gutter / 2}px;
  .ant-collapse {
    background-color: transparent;
    border: 0;
  }
  .ant-collapse-arrow {
    right: ${(props) => props.theme.gutter}px !important;
  }
  .ant-collapse-borderless {
    background-color: transparent;
    .ant-collapse-item {
      border-bottom: 0;
    }
  }
  .ant-collapse-content {
    border-top: 0;
  }
  .ant-collapse-content-box,
  .ant-collapse-header {
    padding: 0 !important;
  }
  .ant-collapse-item {
    border-bottom: 0 !important;
  }
`

ReportCard.defaultProps = {
  collapsible: true,
}

export {ReportCard}
